import { faker } from "@faker-js/faker";
import { useEffect, useState } from "react";
// @mui
import { useSelector } from "react-redux";
import { Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
// sections
import { AppNewsUpdate, AppOrderTimeline } from "../sections/@dashboard/app";
import instance from "../api/axiosRequest";

// ----------------------------------------------------------------------

export default function DashboardApp() {
  const { user } = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  const [enquiries, setEnquiries] = useState([]);

  useEffect(() => {
    const getEnquiries = async () => {
      setLoading(true);
      try {
        const { data } = await instance.get(
          `/enquiry/getEnquiry?vendor_id=${user.id}`
        );
        setEnquiries(
          data.data.rows.sort((a, b) => {
            if (a.createdAt < b.createdAt) return 1;
            if (a.createdAt > b.createdAt) return -1;
            return 0;
          }).slice(0,10)
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log(error.response);
      }
    };
    getEnquiries();
  }, [user]);

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back {user.role === 1 ? "Admin" : user.name}
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <AppNewsUpdate
              title="New Leads"
              list={enquiries}
              loading={loading}
              to="lead-center"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  "1983, orders, $4220",
                  "12 Invoices have been paid",
                  "Order #37745 from September",
                  "New order placed #XF-2356",
                  "New order placed #XF-2346"
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past()
              }))}
            />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
